import React, { useEffect } from "react";
import styles from "./AlertPopup.module.css";

export const AlertPopup = ({
  show,
  onClose,
  children,
  isClosable = true,
  overlayStyle = {},
  contentStyles = {},
  contentClassName = "",
  withHeader = false,
  headerTitle = "Add Title",
  titleClassNames = "",
  titleStyles = {},
  closeOnEscape = true,
  closeButtonClassName = " btn btn-sm btn-outline-secondary",
  isCancelButtonRequired = false,
  isAcceptButtonRequired = false,
  onCancelClick = () => { },
  onAcceptClick = () => { },
  acceptButtonContent = "",
  cancelButtonContent = ""
}) => {

  useEffect(() => {
    if (closeOnEscape && show) {
      const handleEscape = (e) => {
        if (e.key === "Escape") {
          onClose();
        }
      };

      window.addEventListener("keydown", handleEscape);

      return () => {
        window.removeEventListener("keydown", handleEscape);
      };
    }
  }, [show, closeOnEscape, onClose]);

  if (!show) return null;

  return (
    <div
      className={`${styles.modal_overlay}`}
      onClick={isClosable ? onClose : null}
      style={overlayStyle}
    >
      <div
        className={`${styles.modal_content} ${contentClassName} border shadow-lg`}
        onClick={(e) => e.stopPropagation()}
        style={contentStyles}
      >
        {withHeader && (
          <div className="w-100 d-flex justify-content-between align-items-center mb-3">
            <div
              className={`font-weight-bold ${styles.modal_title} ${titleClassNames}`}
              style={titleStyles}
            >
              {headerTitle}
            </div>
          </div>
        )}
        {children}
        <div className="d-flex justify-content-end mt-3">
          {isCancelButtonRequired && <button className="btn btn-sm btn-secondary mr-3" onClick={onCancelClick}>{cancelButtonContent}</button>}
          {isAcceptButtonRequired && <button className="btn btn-sm btn-primary" onClick={onAcceptClick}>{acceptButtonContent}</button>}
        </div>
        {isClosable && (
          <div
            className="position-absolute"
            style={{ top: "20px", right: "20px" }}
          >
            <button
              className={`${closeButtonClassName}`}
              onClick={onClose}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
